import React, { useState, useEffect } from "react";

function AgreementPage({onClose, onAgree}){
  const [isAllChecked, setIsAllChecked] = useState(false);
  const [isUsingChecked, setIsUsingChecked] = useState(false);
  const [isInfoChecked, setIsInfoChecked] = useState(false);
  
  const handleOverlayClick = (e)=>{
    if(e.target === e.currentTarget){
      onClose();
    }
  }

  // ESC 키로 모달 닫기
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };
    document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, [onClose]);

  const handleAllCheck = (e) => {
    console.log('all click');
    const checked = e.target.checked;
    setIsAllChecked(checked);
    setIsUsingChecked(checked);
    setIsInfoChecked(checked);
  }

  useEffect(() => {
    if (isUsingChecked && isInfoChecked) {
      setIsAllChecked(true);
    } else {
      setIsAllChecked(false);
    }
  }, [isUsingChecked, isInfoChecked]);

  const handleClickAgree = () => {
    if(!isAllChecked){
      alert("동의하여 주십시오");
      return;
    }
    onAgree();
  }

  const agreeUsing = `제1장 총칙
    제1조 (목적) 본 약관은 "스플랜플러스"(이하 "서비스")의 이용과 관련하여, 서비스를 제공하는 회사(이하 "회사")와 이를 이용하는 기관(이하 "이용기관") 간의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.
    제2조 (정의)
    1. "서비스"란 회사가 제공하는 스타트업 보육기관 전용 ERP 솔루션으로, 입주기업 정보 관리, 성과 입력, 문서 관리, 자동 보고서 생성, 위치 기반 출석 체크 등을 포함합니다.
    2. "이용기관"이란 본 약관에 동의하고 회사와 서비스 이용계약을 체결한 법인 또는 공공기관을 의미합니다.
    3. "최종사용자"란 이용기관 소속으로 서비스에 접근하여 사용하는 보육 매니저, 입주기업 담당자 등을 포함합니다.
    4. "이용데이터"란 이용기관 및 최종사용자가 서비스 이용 중 저장, 전송한 모든 정보를 말합니다.
    제2장 이용계약 체결
    제3조 (이용신청 및 승낙)
    1. 이용기관은 회사가 제공하는 방식에 따라 서비스 이용을 신청하고, 회사의 승낙에 따라 서비스 이용계약이 체결됩니다.
    2. 이용계약은 계약서 서명 혹은 회사가 승인한 전자계약 방식에 따라 성립됩니다.
    제4조 (약관의 효력 및 변경)
    1. 본 약관은 이용계약 체결 시 효력을 발생하며, 회사는 관련 법령에 따라 본 약관을 수시로 개정할 수 있습니다.
    2. 개정 약관은 서비스 화면 또는 이메일 등으로 공지하며, 이용기관이 이에 이의를 제기하지 않고 계속 이용하는 경우 변경 사항에 동의한 것으로 간주합니다.
    제3장 서비스 제공 및 변경
    제5조 (서비스의 제공)
    1. 회사는 계약된 범위 내에서 서비스를 제공합니다.
    2. 회사는 시스템 점검, 기능 개선 등을 위해 서비스의 일부를 사전 공지 후 수정하거나 일시 중단할 수 있습니다.
    제6조 (서비스의 변경) 회사는 필요 시 서비스 기능을 개선, 추가, 삭제할 수 있으며, 이용기관에 불이익이 있는 경우 사전 공지 후 시행합니다.
    제4장 이용데이터 및 개인정보 보호
    제7조 (데이터 소유권 및 처리)
    1. 서비스 내 입력된 이용데이터의 소유권은 이용기관에 있으며, 회사는 서비스 제공 목적에 한해 접근 및 처리합니다.
    2. 계약 종료 시, 이용기관은 데이터를 백업할 수 있으며, 회사는 일정 기간 이후 데이터 삭제를 수행할 수 있습니다.
    제8조 (개인정보 보호)
    1. 회사는 개인정보 보호법 등 관계 법령을 준수하며, 개인정보 처리방침을 별도로 수립합니다.
    2. 이용기관은 최종사용자의 개인정보 수집 및 이용에 대해 사전 동의를 받아야 하며, 이에 대한 책임은 이용기관에 있습니다.
    제5장 계약 종료 및 손해배상
    제9조 (계약 해지)
    1. 이용기관은 계약 기간 중 언제든지 해지를 요청할 수 있으며, 계약서에 정한 조건에 따릅니다.
    2. 회사는 이용기관이 약관을 위반한 경우 즉시 계약을 해지할 수 있습니다.
    제10조 (면책조항)
    1. 회사는 천재지변, 불가항력, 외부 시스템 장애 등 회사의 귀책사유가 없는 경우 발생한 손해에 대해 책임지지 않습니다.
    2. 회사의 책임 있는 사유로 손해가 발생한 경우, 최근 3개월 간 이용기관이 지급한 서비스 이용료를 한도로 배상 책임을 집니다.
    제6장 기타사항
    제11조 (준거법 및 관할) 본 약관은 대한민국 법률에 따라 해석되며, 회사와 이용기관 간 분쟁이 발생한 경우 회사의 관할 법원으로 합니다.
    제12조 (약관 우선순위) 서비스 개별 계약서와 본 약관 내용이 상충하는 경우, 개별 계약서가 우선 적용됩니다.
    `;

  const agreeInfo = `개인정보처리방침
  제1조 (목적)
  주식회사 스플랜플러스(이하 “회사”)는 이용기관과 최종사용자의 개인정보를 보호하고 관련 법령을 준수하기 위하여 본 개인정보 처리방침을 수립·공개합니다.
  제2조 (개인정보 수집 항목 및 방법)
  1.	수집 항목
  o	[필수] 이름, 이메일, 휴대전화번호, 소속기관명, 직책
  o	[선택] 출석 위치정보, 문서 내 사용자 활동 기록
  2.	수집 방법
  o	서비스 가입, 고객센터 문의, 위치기반 출석기능 이용 시 자동 수집 등
  제3조 (개인정보 이용 목적)
  회사는 수집한 개인정보를 다음 목적에 한해 사용합니다.
  •	사용자 식별 및 서비스 제공
  •	공지사항 전달 및 서비스 개선
  •	위치기반 출석 서비스 제공
  •	이용기관 성과 분석 및 통계
  제4조 (개인정보 보유 및 이용기간)
  회사는 개인정보 수집 및 이용 목적이 달성된 후에는 해당 정보를 지체 없이 파기합니다. 단, 관계 법령에 따라 일정 기간 보관할 수 있습니다.
  제5조 (개인정보의 제3자 제공)
  회사는 원칙적으로 이용자의 개인정보를 외부에 제공하지 않습니다. 단, 아래의 경우는 예외입니다.
  •	이용자의 사전 동의를 받은 경우
  •	법령에 의해 제공이 요구되는 경우
  제6조 (개인정보의 처리 위탁)
  회사는 서비스 운영을 위해 다음의 업무를 위탁할 수 있으며, 위탁 계약 체결 시 개인정보 보호 관련 법령을 준수합니다.
  •	클라우드 서버 운영 및 유지보수
  •	고객 문의 응대 업무 등
  제7조 (정보주체의 권리와 행사 방법)
  이용자 및 법정대리인은 자신의 개인정보에 대해 열람, 정정, 삭제, 처리정지를 요청할 수 있습니다.
  권리는 서면, 이메일, 전화 등을 통해 행사할 수 있으며, 회사는 지체 없이 조치합니다.
  제8조 (개인정보 보호책임자)
  •	성명: 임정동
  •	직책: 대표이사
  •	이메일: lim.jdong@smimfactory.com
  •	전화: 010-3888-3441
  제9조 (위치정보 처리에 관한 사항)
  서비스 내 ‘위치 기반 출석 체크’ 기능은 사용자의 선택에 따라 활성화되며, 해당 위치정보는 실시간 출석 확인 이외의 목적으로 사용되지 않습니다.
  제10조 (개인정보 파기 절차 및 방법)
  1.	파기 절차: 보유기간 종료 후 즉시 파기
  2.	파기 방법: 전자 파일은 복구 불가능한 방식으로 삭제하며, 출력물은 분쇄 또는 소각
  제11조 (개인정보 처리방침 변경)
  본 방침은 관련 법령 또는 서비스 내용 변경에 따라 수시로 변경될 수 있으며, 변경 시 서비스 공지사항 또는 이메일을 통해 사전 고지합니다.
  `;

  return (
    <div style={styles.overlay} onClick={handleOverlayClick}>
      <div style={styles.modal}>
        <h2 className="font-body2-medium" style={{color:"var(--color-blue_20)", marginBottom: "12px"}}>약관 동의</h2>
        <div style={styles.headDivider}></div>
        <div style={styles.rowAgreement}>
          <p style={styles.agreeTitle}>회원가입 약관에 모두 동의합니다.</p>
          <label style={styles.circleCheckBox}>
            <input
              type="checkbox"
              checked={isAllChecked}
              onChange={handleAllCheck}
              style={styles.hiddenCheckbox} // 기본 체크박스 숨김
            />
            <span style={{ ...styles.circle, backgroundColor: isAllChecked ? "#3D435F" : "white" }}>
              {isAllChecked && <span style={styles.innerCircle}></span>} {/* 체크 시 내부 원 표시 */}
            </span>
          </label>
        </div>
        <div style={styles.subDivider}></div>
        <div style={styles.divAgreement}>
          <div style={styles.rowAgreement}>
            <div style={styles.rowAgreeTitle}>
              <p style={styles.agreeTitle}>이용약관 동의</p>
              <p style={{...styles.agreeTitle, color: "var(--color-red_57)"}}>(필수)</p>
            </div>
            <label style={styles.circleCheckBox}>
              <input
                type="checkbox"
                checked={isUsingChecked}
                onChange={(e) => setIsUsingChecked(e.target.checked)}
                style={styles.hiddenCheckbox} // 기본 체크박스 숨김
              />
              <span style={{ ...styles.circle, backgroundColor: isUsingChecked ? "#3D435F" : "white" }}>
                {isUsingChecked && <span style={styles.innerCircle}></span>} {/* 체크 시 내부 원 표시 */}
              </span>
            </label>             
          </div>
          <div style={styles.agreeContent}>
            {agreeUsing}
          </div>
        </div>
        <div style={styles.divAgreement}>
          <div style={styles.rowAgreement}>
            <div style={styles.rowAgreeTitle}>
              <p style={styles.agreeTitle}>개인정보 수집 및 이용 동의</p>
              <p style={{...styles.agreeTitle, color: "var(--color-red_57)"}}>(필수)</p>
            </div>
            <label style={styles.circleCheckBox}>
              <input
                type="checkbox"
                checked={isInfoChecked}
                onChange={(e) => setIsInfoChecked(e.target.checked)}
                style={styles.hiddenCheckbox} // 기본 체크박스 숨김
              />
              <span style={{ ...styles.circle, backgroundColor: isInfoChecked ? "#3D435F" : "white" }}>
                {isInfoChecked && <span style={styles.innerCircle}></span>} {/* 체크 시 내부 원 표시 */}
              </span>
            </label>  
          </div>
          <div style={styles.agreeContent}>
            {agreeInfo}
          </div>
        </div>
        <div style={styles.rowButton}>
          <button onClick={onClose} style={styles.btnClose}>CANCEL</button>
          <button onClick={handleClickAgree} style={styles.btnAgree}>CONFIRM</button>
        </div>
      </div>
    </div>
  );
}

const btnCommon ={
  flex: "1",
  borderRadius: "50px",
  border: "1px solid #B4B5C1",
  fontSize: "16px",
  fontWeight: "500",
  lineHeight: "53px",
  cursor:"pointer",
  color: "var(--color-blue_20)",
  backgroundColor: "white",
}

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)", // 반투명 배경
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  modal: {
    backgroundColor: "white",
    padding: "20px",
    borderRadius: "8px",
    padding: "70px 40px",
    width: "600px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
  },
  headDivider:{
    borderBottom: "2px solid #3D435F"
  },
  circleCheckBox: {
    display: "inline-flex",
    alignItems: "center",
    cursor: "pointer", //
  },

  hiddenCheckbox: {
    display: "none", // 기본 체크박스 숨김
  },
  
  circle: {
    width: "20px",
    height: "20px",
    border: "2px solid #3D435F",
    borderRadius: "50%", // 원형으로 만듦
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: "8px",
    transition: "background-color 0.3s",
  },
  innerCircle: {
    width: "10px",
    height: "10px",
    backgroundColor: "white",
    borderRadius: "50%",
  },
  btnClose: {
    ...btnCommon
  },
  btnAgree:{
    ...btnCommon,
    backgroundColor: "#3D435F",
    borderColor: "#3D435F",
    color: "white"
  },
  rowAgreement:{
    display:"flex",
    alignItems:"center",
    justifyContent:"space-between",
    height: "55px",
    borderBottom: "1px solid #D8D9DF"
  },
  rowAgreeTitle:{
    display:"flex",
    gap:"5px"
  },
  agreeTitle:{
    color: "var(--color-blue_22)",
    fontSize: "14px",
    fontWeight: "400",
  },
  agreeContent:{
    height: "150px",
    width: "100%",
    overflowY: "auto",
    whiteSpace:"pre-line",
    border:"1px solid #D8D9DF",
    padding: "22px 18px 0px 18px",
    boxSizing:"border-box"
  },
  rowButton:{
    display: "flex",
    marginTop:"20px",
    gap: "10px"
  }
};
export default AgreementPage;